// extracted by mini-css-extract-plugin
export default {"video":"video___cd6b07d4ab0502b2","videoPreview":"videoPreview___c06a727ccf05780c"};